export default __webpack_public_path__ + "static/media/mappa_s6.c34c788e.png";